module.exports = __webpack_public_path__ + "img/blue-bg@2x.72928bf3.png";